export default {
  quickBooksToken: {},
}